import moment from 'moment';

export default function formatDate(date: string) {
  return moment.utc(date).format('MM/DD/YYYY');
}
